import type { IconProps } from "./icon-types";

/**
 * 위 방향 chevron. `ChevronIcon`(아래 방향)과 같은 16그리드·stroke 1.8로
 * chevron 가족의 시각 굵기를 통일한다.
 */
export const ChevronUpIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true" {...props}>
    <path
      d="M4 10l4-4 4 4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
